import { render, staticRenderFns } from "./ClaimStatistics.vue?vue&type=template&id=60c427f6&"
import script from "./ClaimStatistics.vue?vue&type=script&lang=js&"
export * from "./ClaimStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports